export const CURRENT_SCHEMA_VERSION:number = 5;
export const TAB = '\t';
export const NEWLINE = '\n';
export const stripTabs = (str: string) => ('' + (str || '')).split(TAB).join('');
export enum LangId { EN = 'en', FR = 'fr' }
export const possibleLanguages = [
  {id: LangId.EN, caption: 'English'},
  {id: LangId.FR, caption: 'Français'},
]